import React from "react";
import { Segmented } from "antd";
import "./SegmentedTab.css";

const CustomTab = ({
  tabs,
  activeTab,
  onTabChange,
  className = "",
  align = "left",
}) => {
  const handleTabChange = (value) => {
    const tabIndex = parseInt(value, 10);
    if (onTabChange) {
      onTabChange(tabIndex); // Notify parent
    }
  };

  const segmentedOptions = tabs.map((tab, index) => ({
    label: tab.label,
    value: index.toString(),
  }));

  return (
    <>
      <div className={`w-auto h-auto ${className}`}>
        <div
          className="flex items-center gap-4"
          style={
            align === "right"
              ? { justifyContent: "flex-end" }
              : { justifyContent: "flex-start" }
          }
        >
          <div>
            <Segmented
              value={activeTab?.toString() ?? "0"}
              onChange={handleTabChange}
              options={segmentedOptions}
              style={{ marginBottom: 8, fontSize: "12px" }}
            />
          </div>
        </div>
      </div>

      {/* Horizontal line separator */}
      {/* <hr className="border-t border-[#8d8d8d] my-4 -mx-6" /> */}

      {/* Tab Content */}
      <div className="text-gray-600 text-left font-poppins text-sm font-medium leading-6 p-1">
        {tabs[activeTab]?.content}
      </div>
    </>
  );
};

export default CustomTab;
